import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appScrollButton]',
    standalone: true
})
export class ScrollButtonDirective {
  constructor(
    private elRef: ElementRef,
  ) {}

  @HostListener('click')
  setActive(): void {
    this.elRef.nativeElement.scrollIntoView({behavior: 'smooth', inline: 'start', block: 'nearest'});
  }
}
